<template>
  <div class="page-nav" :class="modifier">
    <PartsLayoutContainer>
      <div class="page-nav_inner">
        <div v-for="(item, index) in items" :key="index" class="page-nav_item">
          <PartsChromeLink v-if="item.href" :to="item.href" class="page-nav_link">
            {{ item.text }}
          </PartsChromeLink>
          <span v-else>{{ item.text }}</span>
        </div>
      </div>
    </PartsLayoutContainer>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `page-nav`（パンくず）。支給101本中 **61本**に出る
 * （`grep -rl 'class="page-nav"' design-src/20260810/` の実測）。
 *
 * **`<main>` の外に置く。** 支給は `</nav>`（ヘッダー）の直後・`<main>` の前
 * （`design-src/20260810/welcome.html`）。
 *
 * **末尾は必ず `<span>` で出す。** 呼び出し側は末尾に `href: null` を渡すこと。
 *
 * **中間階層は、飛び先のページが存在するときだけリンクにする。** 商品詳細38本の中間
 * （カテゴリ名）は**トップの商品タブ `/?category=<slug>#products` へ飛ばす**（決定#91）。
 * カテゴリ別一覧ページは作らない（決定#23）が、タブの選択状態が `?category=` だけで決まるので
 * 飛び先として成立する。`/news/[id]` の「お知らせ」は `/news` が実在するので支給どおりリンクにする
 * （`design-src/20260810/news/detail.html:449-451`）。
 *
 * 旧 `commons/breadcrumbs.vue`（`l-breadcrumb` ＋ Element Plus）とは別物で、置き換えは
 * 各ページを新デザインへ変換する回に行う（決定#3）。型は旧部品と同じものを使う。
 */
import type { BreadcrumbType } from '@/types/domains/index';

type Props = {
  items: BreadcrumbType.Breadcrumb[];
  /**
   * `page-nav` に足す修飾クラス。商品詳細38本は `product-detail-page-nav` が付く
   * （`design-src/20260810/product-detail/product501.html:305`）
   */
  modifier?: string;
};

withDefaults(defineProps<Props>(), {
  modifier: '',
});
</script>
